import React, { Children } from 'react';
import { Helmet } from 'react-helmet-async';
type SEOHeadProps = {
  title?: string;
  description?: string;
  canonical?: string;
  structuredData?: object;
  ogImage?: string;
  ogType?: string;
};
export const SEOHead = ({
  title = 'Story Bunny - AI-Powered Stories for Children',
  description = 'Create magical AI-powered stories for children ages 3-6. Turn imagination into beautifully illustrated storybooks with safe, child-friendly AI technology.',
  canonical,
  structuredData,
  ogImage = 'https://storybunny.ai/og-image.jpg',
  ogType = 'website'
}: SEOHeadProps) => {
  const fullTitle = title.includes('Story Bunny') ? title : `${title} | Story Bunny`;
  return <Helmet data-id="element-854">
      <title data-id="element-855">{fullTitle}</title>
      <meta name="description" content={description} data-id="element-856" />
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} data-id="element-857" />
      <meta property="og:description" content={description} data-id="element-858" />
      <meta property="og:type" content={ogType} data-id="element-859" />
      <meta property="og:image" content={ogImage} data-id="element-860" />
      <meta property="og:site_name" content="Story Bunny" data-id="element-861" />
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-862" />
      <meta name="twitter:title" content={fullTitle} data-id="element-863" />
      <meta name="twitter:description" content={description} data-id="element-864" />
      <meta name="twitter:image" content={ogImage} data-id="element-865" />
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} data-id="element-866" />}
      {/* Structured Data */}
      {structuredData && <script type="application/ld+json" data-id="element-867">
          {JSON.stringify(structuredData)}
        </script>}
      {/* Additional SEO meta tags */}
      <meta name="robots" content="index, follow" data-id="element-868" />
      <meta name="author" content="Story Bunny AI LLC" data-id="element-869" />
      <meta name="keywords" content="AI stories, children's books, storytelling, kids creativity, educational technology, safe AI for kids" data-id="element-870" />
    </Helmet>;
};